
import React, { useState } from "react";
import { InputGroup, FormControl } from "react-bootstrap";
import { ABSOLUTE_VALUE_OPTION, PERCENTAGE, PERCENTAGE_OPTION, SALVAGE_TYPES } from "../consts";
import "../scss/salvageInputGroup.scss"

const SalvageInputGroup = ({
  calHistory,
  index,
  calHistoryListCreate,
  setCalHistoryListCreate,
  setDisableCalculate,
  setHasSalvageChanged,
}) => {
  const [showOptions, setShowOptions] = useState(false);

  const currentOption =
    calHistory?.calcEntity?.salvageType === PERCENTAGE
      ? PERCENTAGE_OPTION
      : ABSOLUTE_VALUE_OPTION;

  const handleOptionSelect = (data) => {
    calHistoryListCreate[index] = {
      calcEntity: {
        ...calHistoryListCreate[index].calcEntity,
        salvageType: data?.value,
      },
      usersList: calHistoryListCreate[index].usersList,
    };
    setCalHistoryListCreate([...calHistoryListCreate]);
    setDisableCalculate(true);
    setHasSalvageChanged(true);
    setShowOptions(false);
  };

  return (
    <InputGroup className="combined-input">
      {/* Custom Dropdown */}
      <InputGroup.Text
        as="div"
        className="salvage-type-select"
        style={{ position: "relative", cursor: "pointer" }}
        onClick={() => setShowOptions(!showOptions)}
      >        
        <span className="selected-option"> {currentOption.displayText || currentOption.label}</span>
        <span className="dropdown-arrow-icon">▼</span>
    
        {showOptions && (
          <div className="custom-dropdown">
            {SALVAGE_TYPES.map((option) => (
              <div
                key={option.value}
                className="dropdown-item"
                onClick={() => handleOptionSelect(option)}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </InputGroup.Text>

      {/* Input Field */}
      <FormControl
        type="text"
        value={calHistory?.calcEntity?.salvage}
        className="salvage-value"
        onChange={(e) => {
          const inputValue = e.target.value ?? "";
          const hasPercent = inputValue.includes("%");
          const matchValue = inputValue
            .replace(/[^\d.]/g, "")
            .replace(/%/g, "")
            .match(/^\d*(?:\.\d{0,2})?/);
          let num = matchValue ? matchValue[0] : "";
          if (num === ".") num = "0.";
          const updatedValue = hasPercent ? (num ? `${num}%` : "") : num;
          e.target.value = updatedValue;

          calHistoryListCreate[index] = {
            calcEntity: {
              ...calHistoryListCreate[index].calcEntity,
              salvage: e.target.value,
            },
            usersList: calHistoryListCreate[index].usersList,
          };
          setCalHistoryListCreate([...calHistoryListCreate]);
          setDisableCalculate(true);
          setHasSalvageChanged(true);
        }}
      />
    </InputGroup>
  );
};

export default SalvageInputGroup;
